<template>
  <el-image
    :style="{width: width + 'px', height: height + 'px'}"
    :src="bindUrl"
    :preview-src-list="srcList">
  </el-image>
</template>

<script>
export default {
  name: 'DYImage',
  props: {
    value: {
      type: [String, Array],
    },
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 100,
    }
  },
  computed: {
    bindUrl: {
      get() {
        if (typeof this.value === 'string') {
          return this.value
        }
        if (Array.isArray(this.value)) {
          return this.value[0]
        }
      }
    },
    srcList() {
      if (typeof this.value === 'string') {
        return [this.value]
      }
      if (Array.isArray(this.value)) {
        return this.value
      }
      return []
    }
  },
  methods: {},
};
</script>

<style scoped>

</style>
